module.exports = __webpack_public_path__ + "static/img/banner_AI智慧网银.1a382f75.png";